// // frontend/src/components/common/SearchInput.jsx

import React from 'react';
import { Input } from '../ui/input';
import { Search, X } from 'lucide-react';
import { Label } from '../ui/label';
import { cn } from '../../lib/utils';

const SearchInput = ({
  value,
  onChange,
  placeholder = 'Search...',
  label = 'Search',
  className,
  debounce = false, // Optional: enable built-in 500ms debounce
  disabled = false,
}) => {
  // Optional debounce using use-debounce (install once: npm i use-debounce)
  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleClear = () => {
    onChange('');
  };

  return (
    <div className={cn('space-y-2', className)}>
      {label && <Label>{label}</Label>}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        <Input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => handleChange(e)}
          disabled={disabled}
          className="pl-10 pr-10"
          autoComplete="off"
        />
        {value && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Clear search"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchInput;


// frontend/src/components/common/SearchInput.jsx

// import React from 'react';
// import { Input } from '../ui/input';
// import { Search, X } from 'lucide-react';
// import { Label } from '../ui/label';
// import { cn } from '../../lib/utils';
// import { useDebouncedCallback } from 'use-debounce';

// const SearchInput = ({
//   value,
//   onChange,
//   placeholder = 'Search...',
//   label = 'Search',
//   className,
//   debounce = false,           // ← Enable debounce
//   debounceDelay = 500,        // ← Custom delay (ms)
//   disabled = false,
// }) => {
//   // Create debounced version of onChange
//   const debouncedOnChange = useDebouncedCallback((newValue) => {
//     onChange(newValue);
//   }, debounceDelay);

//   const handleChange = (e) => {
//     const newValue = e.target.value;

//     if (debounce) {
//       // Immediate visual feedback + delayed callback
//       // We don't update parent state immediately — only after delay
//       debouncedOnChange(newValue);
//     } else {
//       // Instant update (for client-side filtering)
//       onChange(newValue);
//     }
//   };

//   const handleClear = () => {
//     onChange('');
//   };

//   return (
//     <div className={cn('space-y-2', className)}>
//       {label && <Label>{label}</Label>}
//       <div className="relative">
//         <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
//         <Input
//           type="text"
//           placeholder={placeholder}
//           value={value}
//           onChange={handleChange}
//           disabled={disabled}
//           className="pl-10 pr-10"
//           autoComplete="off"
//         />
//         {value && (
//           <button
//             type="button"
//             onClick={handleClear}
//             className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
//             aria-label="Clear search"
//           >
//             <X className="h-4 w-4" />
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SearchInput;